import styled from '@emotion/styled';
import { borderColor } from '../TableRowContainer/TableRowContainer.styled';
import { StyledProps } from './TableBodyContainer.types';

export default styled.tbody<StyledProps>`
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  list-style-type: none;
  border-collapse: collapse;
  border: 1px ${borderColor};
  border-style: solid;
  font-size: 14px;

  @media (max-width: 1360px) {
    font-size: 13px;
  }

  @media (max-width: 1100px) {
    font-size: 11px;
  }
`;
